import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useCategoriesExportQuery } from "../../services/categoryApi";
import { usePricesExportQuery } from "../../services/priceApi";
import {
  useProductPopularQuery,
  useProductsExportQuery,
} from "../../services/productApi";
import { useSalesQuery } from "../../services/saleApi";
import { useSupplierExportQuery } from "../../services/supplierApi";
import Header from "../Common/Header/Header";
import CategoryExportModal from "../Common/Modal/CategoryExportModal";
import COGS from "../Common/Modal/COGS";
import PopularProductExport from "../Common/Modal/PopularProductExport";
import PriceExportModal from "../Common/Modal/PriceExportModal";
import ProductDetailsExportModal from "../Common/Modal/ProductDetailsExportModal";
import SupplierDetailsExportModal from "../Common/Modal/SupplierDetailsExportModal";
import SideBar from "../Common/SideBar/SideBar";
import { signInUser } from "../Utility/Auth";
import { useSelector } from "react-redux";

const Exports = () => {
  const auth = signInUser();
  const { aamarId, storeSettings } = auth;
  const lang = useSelector((state) => state.languageReducer);

  const [onShow, setOnShow] = useState(false);
  const [onShowSupplier, setOnShowSupplier] = useState(false);
  const [onShowCategory, setOnShowCategory] = useState(false);
  const [onShowSale, setOnShowSale] = useState(false);
  const [onShowPrice, setOnShowPrice] = useState(false);
  const [onShowPopular, setOnShowPopular] = useState(false);
  const [salesExport, setSalesExport] = useState([]);
  const [testExport, setTestExport] = useState(false);
  const [warehouse, setWarehouse] = useState("");

  const [startDate, setStartDate] = useState(format(new Date(), "MM-dd-yyyy"));
  const [endDate, setEndDate] = useState(format(new Date(), "MM-dd-yyyy"));

  const handleClose = () => setOnShow(false);
  const handleCloseSupplier = () => setOnShowSupplier(false);
  const handleCloseCategory = () => setOnShowCategory(false);
  const handleClosePrice = () => setOnShowPrice(false);
  const handleCloseSale = () => setOnShowSale(false);
  const handleClosePopularSale = () => setOnShowPopular(false);
  const handleCloseTest = () => setTestExport(false);

  const { data, isSuccess, refetch } = useProductsExportQuery({
    aamarId,
  });

  const {
    data: supplier,
    isSuccess: supplierSuccess,
    refetch: supplierRefetch,
  } = useSupplierExportQuery({ warehouse, aamarId });

  const {
    data: category,
    isSuccess: categorySuccess,
    refetch: categoryRefetch,
  } = useCategoriesExportQuery({ aamarId });

  const { data: price, isSuccess: priceSuccess } = usePricesExportQuery({
    warehouse,
    aamarId,
  });
  const { data: popular, isSuccess: popularSuccess } = useProductPopularQuery({
    warehouse,
    aamarId,
  });
  // const { data: test, isSuccess: testSuccess } = useSupplierTestQuery("62e91c15666a53f12aa41591");
  const sales = useSalesQuery({ warehouse, aamarId });
  // console.log("test", test)

  useEffect(() => {
    let products = [];

    let i = 1;
    sales?.data?.map((sale) => {
      if (sale?.products !== null) {
        sale?.products?.map((product) => {
          if (product.article_code) {
            products = [
              ...products,
              {
                invoiceId: sale?.invoiceId ? sale.invoiceId : __dirname,
                article_code: product?.article_code,
                mrp: product?.mrp,
                qty: product?.qty,
                date: format(new Date(sale?.createdAt), "MM/dd/yyyy"),
              },
            ];
          }
        });
      }
      // console.log(i++);
      // console.log("COGS", products);
      setSalesExport(products);
    });
    // console.log("Loop Complete");
  }, [sales.isSuccess]);

  useEffect(() => {
    refetch();
  }, [warehouse]);

  useEffect(() => {
    setWarehouse(auth?.warehouse);
  }, [auth]);

  const handleProductExport = () => {
    // console.log("hello");
    setOnShow(true);
    // console.log(onShow);
  };

  const handleSupplierExport = () => {
    setOnShowSupplier(true);
    // console.log("hello1");
  };

  const handleCategoryExport = () => {
    setOnShowCategory(true);
  };
  const handlePriceTableExport = () => {
    // console.log(price)
    setOnShowPrice(true);
  };
  const handlePopularProductsExport = () => {
    // console.log(price)
    setOnShowPopular(true);
  };
  const handleProductMatching = () => {
    // console.log(price)
    // setOnShowPopular(true)
    setTestExport(true);
  };
  const handleSaleExport = () => {
    // console.log(price)
    setOnShowSale(true);
  };
  const preHeader = [
    [`${storeSettings?.storeName || "No-Name"}`],
    [`${storeSettings?.address?.street || "No-Street"}`],
    [
      `${storeSettings?.address?.city || "No-City"}-${
        storeSettings?.address?.post || "No-PostalCode"
      }`,
    ],

    [], // Empty row for spacing
  ];

  return (
    <div>
      <div className="container-fluid ">
        <div className="row">
          <div className="col-md-2">
            <SideBar></SideBar>
          </div>
          <div className="col-md-10">
            <Header title="Exports"></Header>
            <div className="mt-2 mt-md-5 d-md-flex justify-content-between align-items-center ">
              <div className="d-flex justify-content-between  align-items-center gap-md-5">
                <div className="me-md-5">
                  <h4>{lang?.products}</h4>
                  <div>
                    <Button
                      className="btn btn-dark  btn-sm "
                      onClick={() => handleProductExport()}
                    >
                      Export Product Details
                    </Button>
                  </div>
                </div>
                <div className="ms-md-5">
                  <h4>{lang?.supplier}</h4>
                  <div>
                    <Button
                      className="btn btn-dark  btn-sm "
                      onClick={() => handleSupplierExport()}
                    >
                      Export Product Details
                    </Button>
                  </div>
                </div>
              </div>
              <div className=" d-flex justify-content-between  align-items-center gap-md-5 mt-4 mt-md-0">
                <div className="me-md-5 ">
                  <h4>{lang?.category}</h4>
                  <div>
                    <Button
                      className="btn btn-dark btn-sm  "
                      onClick={() => handleCategoryExport()}
                    >
                      Export Category Details
                    </Button>
                  </div>
                </div>

                {/* <div className="col-md-4">
                <div>
                  <h4>Price Table</h4>
                  <div>
                    <Button
                      className="btn btn-dark mb-2 float-start me-2"
                      onClick={() => handlePriceTableExport()}
                    >
                      Export Price Details
                    </Button>
                  </div>
                </div>
                    </div> */}

                <div className="ms-md-5 me-md-5">
                  <h4>{lang?.popularProducts}</h4>
                  <div>
                    <Button
                      className="btn btn-dark btn-sm  "
                      onClick={() => handlePopularProductsExport()}
                    >
                      Export Popular Products
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-2 mt-md-5 d-md-flex justify-content-between align-items-center mt-4 mt-md-0">
              <div className="d-flex justify-content-between  align-items-center gap-2 gap-md-4">
                <div>
                  <h4>{lang?.categorySalesReport}</h4>
                  <Link
                    to="/categorySaleExport"
                    className="btn btn-dark btn-sm "
                    // onClick={() => setShow(true)}
                  >
                    Export Category Sales Report
                  </Link>
                </div>

                <div className="ms-md-5">
                  <h4>{lang?.supplierSalesReport}</h4>
                  <Link
                    to="/supplierSaleExport"
                    className="btn btn-dark btn-sm "
                    // onClick={() => setShow(true)}
                  >
                    Export Supplier Sales Report
                  </Link>
                </div>
              </div>

              <div className="d-flex justify-content-between  align-items-center gap-md-5 mt-4 mt-md-0">
                <div>
                  <h4>{lang?.allCategorySalesReport}</h4>
                  <Link
                    to="/allCategorySales"
                    className="btn btn-dark btn-sm "
                    // onClick={() => setShow(true)}
                  >
                    All Category Sales Report
                  </Link>
                </div>

                <div>
                  <h4>{lang?.sampleImportFiles}</h4>
                  <a
                    target="_blank"
                    href="https://drive.google.com/drive/folders/1fqSXoDEcjhqLHAhkgjtV5CHMw-OG6oGA"
                    className="btn btn-dark btn-sm "
                    rel="noreferrer"
                    // onClick={() => setShow(true)}
                  >
                    Sample Import Files
                  </a>
                </div>
              </div>
            </div>
            <div>
              {/* <div className="col-md-4">
                <div>
                  <h4>Product Matching</h4>
                  <div>
                    <Button
                      className="btn btn-dark mb-2 float-start me-2"
                      onClick={() => handleProductMatching()}
                    >
                      Export Popular Products
                    </Button>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-md-4">
                <div>
                  <h4>COGS</h4>
                  <div>
                    <Button
                      className="btn btn-dark mb-2 float-start me-2"
                      onClick={() => handleSaleExport()}
                    >
                      Export Lifetime Sales
                    </Button>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <ProductDetailsExportModal
        preheader={preHeader}
        onShow={onShow}
        handleClose={handleClose}
        exportProduct={data}
      ></ProductDetailsExportModal>

      <SupplierDetailsExportModal
        preheader={preHeader}
        onShow={onShowSupplier}
        handleClose={handleCloseSupplier}
        exportSupplier={supplier}
      ></SupplierDetailsExportModal>
      <COGS
        exportProduct={salesExport}
        handleClose={handleCloseSale}
        onShow={onShowSale}
      />

      <CategoryExportModal
        preheader={preHeader}
        onShow={onShowCategory}
        handleClose={handleCloseCategory}
        exportCategory={category}
      ></CategoryExportModal>
      <PriceExportModal
        onShow={onShowPrice}
        handleClose={handleClosePrice}
        exportPrice={price}
      ></PriceExportModal>
      <PopularProductExport
        preheader={preHeader}
        onShow={onShowPopular}
        handleClose={handleClosePopularSale}
        exportPopular={popular}
      ></PopularProductExport>
      {/* <SupllierMatchedProduct
        onShow={testExport}
        handleClose={handleCloseTest}
        exportPopular={test}
      >
      </SupllierMatchedProduct> */}
    </div>
  );
};

export default Exports;
